import React from "react";

/**
 * 필드 출처 배지 — OCR vs DB 보강 vs 빈값
 *
 * Pure OCR 패러다임: 양식에서 추출한 값(_raw)과 DB 보강 값(_enrichment.db_augmented)
 * 을 시각적으로 구분하여 검수자가 출처를 빠르게 인식하도록 함.
 *
 * props:
 *   fieldKey: string — 필드 키 (예: 'owner_id_no')
 *   value: string|null — 정규화된 값 (response.fields[fieldKey])
 *   rawValue: string|null — 양식 원본 (response._raw[fieldKey])
 *   dbAugmented: string|null — DB 보강 값 (response._enrichment.db_augmented[fieldKey])
 */
export default function FieldSourceBadge({
  fieldKey,
  value,
  rawValue,
  dbAugmented,
}) {
  // Case 1: 빈값 — 양식에도 없고 DB 보강도 없음
  if (!value && !dbAugmented) {
    return (
      <span className="text-gray-400 text-[10px]" title="빈값">
        —
      </span>
    );
  }
  // Case 2: OCR — 양식 raw 값 존재 (Pure OCR 출처)
  if (value && rawValue) {
    return (
      <span
        className="text-blue-600 text-[10px] font-medium whitespace-nowrap"
        title={`양식에서 추출 (raw: ${rawValue})`}
      >
        ✓ OCR
      </span>
    );
  }
  // Case 3: DB 보강 — 양식에는 없고 DB lookup 으로 채움
  if (dbAugmented && !value) {
    return (
      <span
        className="text-amber-600 text-[10px] font-medium whitespace-nowrap"
        title={`통관 DB 보강 (${dbAugmented})`}
      >
        🔍 DB
      </span>
    );
  }
  // Case 4: 정규화 후 값은 있는데 raw 가 없는 경우 (Legacy/Unknown)
  return (
    <span className="text-gray-400 text-[10px]" title="출처 불명">
      ?
    </span>
  );
}
